module.exports = __webpack_public_path__ + "media/images/basic-logos/success-b7bfa61cb458554283852b82bcf41edc.svg";